import React from "react"

export default class TermsAndConditions extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="row">
				<div className="col-sm-12">
					<div className="TermsAndConditions">
						<input type="checkbox" /> I agree to the <a href="#">terms and conditions</a>
					</div>
				</div>
			</div>
		);	
	}

}